export { NAME as DMS_MODULE } from '../constants';

export const NAME = 'VozidloPujcovna';
export const CRUMB_LABEL_KEY = 'repVozidlopa';
export const TRZBY = 'VozidlopaTrzby';
export const EXISTUJICI_ZAPUJCKY = 'ExistujiciZapujcky';

export const DEPENDENT_TABLES = <const>[
	TRZBY,
	EXISTUJICI_ZAPUJCKY,
];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];
